import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SecuredSessionStorageService {
  constructor() {}

  setSessionVariable(key: string, value: string) {
    sessionStorage.setItem(key, btoa(value));
  }

  /**
   * 
   * @param key La llave asignada a la variable de sesión
   * @returns La variable de sesión
   * @throws Error si la variable no existe o no cumple con el formato
   */
  getSessionVariable(key: string): any{
    try {
      const sessionVar = sessionStorage.getItem(key);
      if (!sessionVar) {
        throw new Error('No se obtuvo la variable de sesión');
      }
      return atob(sessionVar);
    } catch (error: any) {
      throw new Error(
        'El valor almacenado en sesión no tiene el formato adecuado'
      );
    }
  }

  cleanSessionStorage() {
    sessionStorage.clear();
  }
}
